// extracted by mini-css-extract-plugin
export var content = "Terms-module__content___pp0ht";
export var ol = "Terms-module__ol___ThIiw";
export var ol2 = "Terms-module__ol2___t3OPW";
export var liStrong = "Terms-module__liStrong___IUAf3";